import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { JOURNEY_STEPS } from './salesData';
export function JourneySection() {
  return <section id="sistema" className="bg-sand py-14 sm:py-20" data-id="element-195" data-mp="3t3h5y8rodov6">
      <div className="mx-auto max-w-4xl px-5" data-id="element-196" data-mp="1w4ortqslbf9">
        <div className="text-center" data-id="element-197" data-mp="1wwl56s7rd6l">
          <SectionTag className="bg-white" data-id="element-198" data-mp="1ts61ed7mx15">El recorrido</SectionTag>
          <h2 className="mx-auto mt-4 max-w-[20ch] font-display text-[1.6rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[28ch] sm:text-[2.4rem]" data-id="element-199" data-mp="pm8o3owy6p0g">
            De “me gusta hacer cosas dulces” a{' '}
            <span className="text-gold" data-id="element-200" data-mp="gndjgh9jxmz9">tener un menú listo para vender</span>.
          </h2>
        </div>

        <ol className="mt-9 grid gap-3.5" data-id="element-201" data-mp="kogvstse50vq">
          {JOURNEY_STEPS.map((step, i) => <motion.li key={step.num} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(i, 4) * 0.05
        }} className="flex items-start gap-4 rounded-2xl border border-stone bg-white p-5 shadow-[0_12px_34px_-26px_rgba(56,37,34,0.55)] sm:gap-5 sm:p-6" data-id="element-202" data-mp="31dclyb7tv3uh" data-mpi={i}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-sand font-display text-[1.05rem] font-extrabold text-gold sm:h-12 sm:w-12 sm:text-[1.2rem]" data-id="element-203" data-mp="34d3k6t07f2ew">
                {step.num}
              </span>
              <div data-id="element-204" data-mp="3s495vostsox4">
                <h3 className="font-display text-[1.05rem] font-bold leading-snug tracking-tight text-charcoal sm:text-[1.2rem]" data-id="element-205" data-mp="3s4r42qz1td7o">
                  {step.title}
                </h3>
                <p className="mt-1.5 max-w-[54ch] font-sans text-[0.88rem] leading-relaxed text-taupe sm:text-[0.94rem]" data-id="element-206" data-mp="4z9u1x2s27dg">
                  {step.desc}
                </p>
              </div>
            </motion.li>)}
        </ol>

        <div className="mt-10 flex flex-col items-center gap-2.5" data-id="element-207" data-mp="2ttpswfytaim7">
          <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-208" data-mp="2yqzral46i4m6" />
          <p className="font-sans text-[0.74rem] font-medium text-taupe" data-id="element-209" data-mp="2ypex4wls0nou">
            Acceso inmediato · Compra única
          </p>
        </div>
      </div>
    </section>;
}